import { useEffect, useState } from "react";
import { getWelcomeDestination, WelcomeDestination } from "@/controllers/subscription";

/** Where every new subscriber went before this existed. */
export const DEFAULT_WELCOME_DESTINATION: WelcomeDestination = { path: "/markets-overview?tour=welcome", label: "the markets overview" };

/**
 * The app page a new subscriber came for (TED works it out from the ad landing page they
 * arrived on), so the welcome screen sends them there instead of the generic overview. Falls
 * back to the overview while loading or when nothing is known.
 */
const useWelcomeDestination = (enabled = true): WelcomeDestination => {
    const [destination, setDestination] = useState<WelcomeDestination>(DEFAULT_WELCOME_DESTINATION);
    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;
        getWelcomeDestination()
            .then((d) => {
                if (!cancelled && d?.path && d.path.startsWith("/")) setDestination(d);
            })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, [enabled]);
    return destination;
};

export default useWelcomeDestination;
